import React, {} from 'react';
import {MarkerType, getMarkerEnd} from 'react-flow-renderer';
import {connect} from "react-redux";
import {getSmartPath} from "./smartPath";

interface Props {
    id: string
    sourceX: number
    sourceY: number
    targetX: number
    targetY: number
    sourcePosition: any
    targetPosition: any
    style: any
    data: {
        source: {
            height: number,
            width: number,
            position: number
        },
        transitionIndex: number,
        transitionCount: number
    }
    arrowHeadType: MarkerType
    markerEndId: string
}
const defaultStyle = {
    "stroke": "#222222",
    "strokeWidth": 2
};
function ButtonEdge({id, data, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition,
                        style = defaultStyle, arrowHeadType, markerEndId}: Props) {
    const [sourceId, targetId,] = id.split(".");
    const source = {id: sourceId, x: sourceX, y: sourceY, position: sourcePosition};
    const target = {id: targetId, x: targetX, y: targetY, position: targetPosition};
    const margin = 40;
    const nodeDimensions = {width: data.source.width, height: data.source.height};
    const edgePath = getSmartPath(source, target, nodeDimensions, data.source.position, data.transitionIndex, data.transitionCount, margin);
    const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
 
    return (
        <path id={id} style={style} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd}/>
    )
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(ButtonEdge);
